import { Link } from "react-router-dom"
import Head from "./Head"

const PageNav = (titleHead, url, logo, title, titlepage = null) => {
    return(
        <div className="breadcrumbs">
            <Head title={titleHead} url={url} logo={logo} />
            <div className="page-header d-flex align-items-center" >
                <div className="container position-relative">
                <div className="row d-flex justify-content-center">
                    <div className="col-lg-6 text-center">
                    <h2>{ title }</h2>
                    <p>{ titlepage }</p>
                    <br />
                    </div>
                </div>
                </div>
            </div>
            <nav>
                <div className="container">
                <ol>
                    <li><Link to="/">Acceuil</Link></li>
                    <li>{ title }</li>
                </ol>
                </div>
            </nav>
            </div>
    )
}

export default PageNav